import React from "react";
import BaseStepComponent from "./common/BaseStepComponent";

const Step1 = () => {
  return (
    <BaseStepComponent
      stepNumber={1}
      title="Tele-Collection Process"
      videoSrc="https://contentmedius.s3.ap-south-1.amazonaws.com/part_1_-_tele-collection_process+(360p).mp4"
      directLink="https://contentmedius.s3.ap-south-1.amazonaws.com/part_1_-_tele-collection_process+(360p).mp4"
      nextStep={2}
    />
  );
};

export default Step1; 